import {KTSVG} from 'helpers'
import React from 'react'
import {useTranslation} from 'react-i18next'

// type Props = {}

const ThankYouPage = () => {
 const {t} = useTranslation()

 return (
  <>
   <div className='container bg-white'>
    <div className='flex justify-center min-h-full sm:pt-2'>
     <div className='w-[320px] p-6'>
      <div className='w-full text-center items-center'>
       <div className='border-b border-[#CED8E0] pb-2 pt-4'>
        <p className='text-[#33393D] font-bold text-2xl'>
         {t('registerPage.thankYou')}
        </p>
        <p className='text-[33393D] font-normal text-base mt-3 w-'>
         {t('registerPage.successMsg')}
        </p>
       </div>

       <div className='flex justify-center items-center mt-7'>
        <KTSVG
         className={''}
         path='/media/icons/registerSuccess.svg'
        />
       </div>
      </div>
     </div>
    </div>
   </div>
  </>
 )
}

export default function ThankYouPageWrapper() {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 return (
  <>
   {/* <PageTitle
        breadcrumbs={[{title: 'sdf', path: 'login', isActive: false}]}
        description='Welcome'
      >
        Welcome Page
      </PageTitle> */}
   <ThankYouPage />
  </>
 )
}
